import { StaticRoutePaths } from '../Common/ClientRoutes';
import { UserRole } from '../Common/UserRole';
import images from '../Common/Images';
import svgs from '../Common/Svgs';

import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';
import localStorage from './LocalStorage';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') ? localStorage.getFromStorage('lang') : navigator.language.substring(0, 2));

const Users = {
    id: 1,
    title: strings.Users,
    description: strings.users_description,
    image: images.USERS_IMAGE,
    svg: svgs.users,
    link: StaticRoutePaths.USERS
};

const Companies = {
    id: 2,
    title: strings.Companies,
    description: strings.companies_description,
    image: images.COMPANIES_IMAGE,
    svg: svgs.companies,
    link: StaticRoutePaths.COMPANIES
};

const Pharmacy = {
    id: 3,
    title: strings.Pharmacies,
    description: strings.Pharmacy_description,
    image: images.PHARMACY_IMAGE,
    link: StaticRoutePaths.PHARMACIES,
    svg: svgs.pharmacy
};

const Statistics = {
    id: 4,
    title: strings.Statistics,
    description: strings.Statistics_description,
    image: images.STATISTICS_IMAGE,
    svg: svgs.statistics,
    link: StaticRoutePaths.STATISTICS
};

const Orders = {
    id: 5,
    title: strings.Orders,
    description: strings.Orders_description,
    image: images.ORDERS_IMAGE,
    svg: svgs.orders,
    link: StaticRoutePaths.ORDERS
};

const Patients = {
    id: 6,
    title: strings.Patients,
    description: strings.Patients_description,
    image: images.PATIENTS_IMAGE,
    svg: svgs.patients,
    link: StaticRoutePaths.PATIENTS
};

export const LayoutState = Object.freeze({
    [UserRole.ADMIN]: [Users, Companies, Pharmacy, Statistics, Orders, Patients],
    [UserRole.STORE_OWNER]: [Users, Pharmacy, Statistics, Orders, Patients],
    [UserRole.PHARMACY_MANAGER]: [Users, Orders, Patients],
    [UserRole.PHARMACIST]: [Orders, Patients]
});



// WEBPACK FOOTER //
// ./src/customModules/Common/HomeLayout.js